import { useInstallerContext } from '../context/InstallerContext';
import { useEffect } from 'react';
import { useHandleInstallationValidations } from './useHandleInstallationValidations';
import { useHandlePostInstallation } from './useHandlePostInstallation';
import { useModalsAndWindow } from '../context/ModalsAndWindowContext';
import { useRenderControl } from '../context/InstallerRenderControlContext';
import { Modals } from '../types';
import { shouldShowConsent } from '../utils/consent';
import { useProvisionApp } from './useProvisionApp';
import { useShouldOpenNewWindow } from './useShouldOpenNewWindow';
export const useInstallationFlow = () => {
  const {
    modals,
    setActiveModal,
    newWindowHandlers
  } = useModalsAndWindow();
  const {
    prerequisitesState,
    setInstallerUiReady
  } = useRenderControl();
  const {
    preInstallationData,
    onInstallationCompleted,
    version
  } = useInstallerContext();
  const provisionAppApi = useProvisionApp();
  const handleInstallationValidations = useHandleInstallationValidations();
  const handlePostInstallation = useHandlePostInstallation();
  const shouldOpenNewWindow = useShouldOpenNewWindow();
  const {
    app,
    isAdvancedOauthApp
  } = preInstallationData;
  useEffect(() => {
    if (prerequisitesState.isDetermined) {
      (async () => {
        await handleInstallationValidations();
        if (app) {
          if (shouldShowConsent(app, version)) {
            await modals.userConsent.open({
              shouldOpenNewWindow
            });
          } else {
            setInstallerUiReady();
          }
          if (shouldOpenNewWindow) {
            newWindowHandlers.openWindow();
            // advanced oauth app gets a loader only after first redirect in useOauthBroadcastRedirectHandler
            if (!isAdvancedOauthApp) {
              newWindowHandlers.showLoader();
            }
            setActiveModal(Modals.goToOtherTab);
          } else {
            setActiveModal(Modals.installingLoader);
          }
          const provisionSuccessData = await provisionAppApi();
          if (provisionSuccessData) {
            await handlePostInstallation(provisionSuccessData, shouldOpenNewWindow);
            onInstallationCompleted(provisionSuccessData);
          }
        }
      })();
    }
  }, [app, prerequisitesState.isDetermined]);
};
//# sourceMappingURL=useInstallationFlow.js.map